import { useState as r, useEffect as a, Children as m, isValidElement as f } from "react";
function l(e) {
  const [s, o] = r({});
  return a(() => {
    o(
      Object.fromEntries(
        m.toArray(e).map((t) => t).filter((t) => f(t)).map((t) => [
          t.type.displayName,
          t
        ])
      )
    );
  }, [e]), s;
}
export {
  l as useSlots
};
